import {redirect} from 'react-router-dom';
import {store as AppStore} from '../store/store';

export function redirectIfUnauthorized(store: typeof AppStore, path = '/login') {
    const token = store.getState().exchangeToken.token;
    if (!token) {
        return redirect(path);
    }
    return null;
}

export function redirectIfAuthorized(store: typeof AppStore, path = '/') {
    const token = store.getState().exchangeToken.token;
    if (token) {
        return redirect(path);
    }
    return null;
}
